// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"_3XOCW3-aPjKDxLod-jlMHb","cancelBtn":"_1tu4am08YedxuZjn-YT8_V","icon":"_3xO0q34VT0oICFK4B5R_i5","saveBtn":"_12FsEBtSiZNWDEuLSatU0y"};